import { init, version } from './core.js';
import type { SiteFlowHandle, SiteFlowOptions } from './types.js';

/**
 * Captured while the script is still executing so the data-attribute
 * configuration can be read after the bundle finishes evaluating.
 */
const hostScript =
  typeof document !== 'undefined' ? (document.currentScript as HTMLScriptElement | null) : null;

function boolAttr(value: string | null | undefined): boolean {
  return value === '' || value === 'true';
}

/**
 * Zero-config entry point: a plain `<script src=… data-site-key=…>` tag is all a
 * static site needs, which is the whole point of this product.
 */
function autoInit(): SiteFlowHandle | null {
  const siteKey = hostScript?.getAttribute('data-site-key');
  if (!siteKey) return null;

  const options: SiteFlowOptions = {
    siteKey,
    apiBaseUrl: hostScript?.getAttribute('data-api-base') ?? '',
    debug: boolAttr(hostScript?.getAttribute('data-debug')),
  };

  const page = hostScript?.getAttribute('data-page');
  if (page) options.page = page;
  const locale = hostScript?.getAttribute('data-locale');
  if (locale) options.locale = locale;

  return init(options);
}

const auto = autoInit();

export { init, version, auto };
